import React from 'react';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { withTranslation } from 'react-i18next';

function SimpleTableHead(props) {
    const {t} = props;
    return (
        <TableHead>
            <TableRow>
                {props.actions &&
                    <TableCell key="actions">
                        {t('Actions')}
                    </TableCell>
                }
                {props.tableCells.map((tableCell) => (
                    <TableCell key={tableCell.id} align={tableCell.centered ? "center" : "inherit"}>
                        {tableCell.label}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

export default withTranslation()(SimpleTableHead);